import type { ReplyType } from "./types"

/** The channel a reply actually goes out on, once the live channel lookup has answered. */
export function sendChannel<T>(
	replyType: ReplyType,
	liveChannel: T | "email" | null,
): ReplyType {
	if (replyType === "custom") return "email"
	return replyType === "live-chat" && liveChannel === "email"
		? "email"
		: replyType
}

/** The channel a thread's reply goes out on, from where the conversation started. */
export function replyTypeFor(
	thread: {
		origin: string
		liveChatSession?: { isFinished?: boolean | null } | null
	},
	isWidgetLiveChatEnabled: boolean,
): ReplyType {
	if (thread.origin === "SLACK_CONNECT") return "slack"
	if (thread.origin === "SLACK") return "disabled"
	if (thread.origin === "TEAMS") return "teams"
	if (thread.origin === "CUSTOM") return "custom"
	if (thread.liveChatSession && thread.origin === "LIVE_CHAT") {
		if (!thread.liveChatSession.isFinished) return "live-chat"
	}
	if (thread.origin === "AI_CHAT" && isWidgetLiveChatEnabled) {
		return "live-chat"
	}
	return "email"
}
